import { createAction, props } from '@ngrx/store';
import {
    CompanySegmentationDTO,
    CustomerSegmentationEntryDTO,
    CreateCompanySegmentationRequestDTO,
    UpdateCompanySegmentationRequestDTO
} from '@iota/inh-core-v1-management-client';

export enum CustomerSegmentationActionTypes {
    LoadCustomerSegmentationOptions = '[CustomerSegmentation] Load Customer Segmentation Options',
    LoadCustomerSegmentationOptionsSuccess = '[CustomerSegmentation] Load Customer Segmentation Options Success',
    LoadCustomerSegmentationOptionsFailure = '[CustomerSegmentation] Load Customer Segmentation Options Failure',

    LoadCompanySegmentation = '[CustomerSegmentation] Load Company Segmentation',
    LoadCompanySegmentationSuccess = '[CustomerSegmentation] Load Company Segmentation Success',
    LoadCompanySegmentationFailure = '[CustomerSegmentation] Load Company Segmentation Failure',

    CreateCompanySegmentation = '[CustomerSegmentation] Create Company Segmentation',
    CreateCompanySegmentationSuccess = '[CustomerSegmentation] Create Company Segmentation Success',
    CreateCompanySegmentationFailure = '[CustomerSegmentation] Create Company Segmentation Failure',

    UpdateCompanySegmentation = '[CustomerSegmentation] Update Company Segmentation',
    UpdateCompanySegmentationSuccess = '[CustomerSegmentation] Update Company Segmentation Success',
    UpdateCompanySegmentationFailure = '[CustomerSegmentation] Update Company Segmentation Failure'
}

export const LoadCustomerSegmentationOptions = createAction(CustomerSegmentationActionTypes.LoadCustomerSegmentationOptions);

export const LoadCustomerSegmentationOptionsSuccess = createAction(
    CustomerSegmentationActionTypes.LoadCustomerSegmentationOptionsSuccess,
    props<{
        industries: CustomerSegmentationEntryDTO[];
        tariffModels: CustomerSegmentationEntryDTO[];
        enterpriseSizes: CustomerSegmentationEntryDTO[];
        bgmMaturityLevels: CustomerSegmentationEntryDTO[];
    }>()
);

export const LoadCustomerSegmentationOptionsFailure = createAction(
    CustomerSegmentationActionTypes.LoadCustomerSegmentationOptionsFailure,
    props<{ error: any }>()
);

export const LoadCompanySegmentation = createAction(
    CustomerSegmentationActionTypes.LoadCompanySegmentation,
    props<{ companyId: string }>()
);

export const LoadCompanySegmentationSuccess = createAction(
    CustomerSegmentationActionTypes.LoadCompanySegmentationSuccess,
    props<{ segmentation: CompanySegmentationDTO }>()
);

export const LoadCompanySegmentationFailure = createAction(
    CustomerSegmentationActionTypes.LoadCompanySegmentationFailure,
    props<{ error: any }>()
);

export const CreateCompanySegmentation = createAction(
    CustomerSegmentationActionTypes.CreateCompanySegmentation,
    props<{ companyId: string; request: CreateCompanySegmentationRequestDTO }>()
);

export const CreateCompanySegmentationSuccess = createAction(
    CustomerSegmentationActionTypes.CreateCompanySegmentationSuccess,
    props<{ segmentation: CompanySegmentationDTO }>()
);

export const CreateCompanySegmentationFailure = createAction(
    CustomerSegmentationActionTypes.CreateCompanySegmentationFailure,
    props<{ error: any }>()
);

export const UpdateCompanySegmentation = createAction(
    CustomerSegmentationActionTypes.UpdateCompanySegmentation,
    props<{ companyId: string; request: UpdateCompanySegmentationRequestDTO }>()
);

export const UpdateCompanySegmentationSuccess = createAction(
    CustomerSegmentationActionTypes.UpdateCompanySegmentationSuccess,
    props<{ segmentation: CompanySegmentationDTO }>()
);

export const UpdateCompanySegmentationFailure = createAction(
    CustomerSegmentationActionTypes.UpdateCompanySegmentationFailure,
    props<{ error: any }>()
);
